export { default as CarouselShadow } from './CarouselShadow'
